import { fields } from 'react/components/DataImportSftp/utils/fields';

Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.FTP = (function () {

    function FTP() {

        this.type = 'FTP';

        Greenmile.DataImport.Scheduler.apply(this, arguments);


        this.changeScheduler = function () {
            var id = this.scheduleList.getValue(),
                schedule = this.listOfSchedules.filter(function (item) {
                    return parseInt(item.id) === parseInt(id);
                })[0];

            schedule = schedule || {
                layout: {
                    id: "NEW"
                }
            };

            this.scheduleName.setValue(schedule.name || "");
            if (schedule.externalStorage) {
                this.externalStorage.setValue(schedule.externalStorage);
            } else {
                this.externalStorage.clear();
            }
            const timeZoneValue = Greenmile.DataImport.Utils.getTimeZoneValue(schedule.timeZoneId);
            if (timeZoneValue) {
                this.timeZone.setValue(timeZoneValue);
            } else {
                this.timeZone.clear();
            }
            this.fileName.setValue(schedule.fileName || "");
            this.runInterval.setValue(schedule.runInterval || "");
            this.runIntervalUnit.setValue(schedule.runIntervalUnit || "");
            this.timeDay.setValue(schedule.runAt || "");
            this.schedulerInterval.setValue("");
            if (schedule.runAt) {
                this.schedulerInterval.setValue("EVERYDAY");
            } else {
                this.schedulerInterval.setValue("INTERVAL");
            }

            var actions = schedule.importActions;
            var actionValue = '';
            this.scheduleActions.clear();
            if (actions && actions[0]) {
                this.scheduleActions.setValue(actions[0].actionType);
                actionValue = actions[0].actionValue || actionValue;
            }
            this.scheduleActions.rootEl.querySelector('#actionValue input').value = actionValue;


            this.mappingTemplate.templatePicklist.setValue(schedule.layout.id.toString());
            if (schedule.importType) {
                this.mappingTemplate.typeImportList.setValue(schedule.importType.toString())
            }
            Greenmile.DataImport.Utils.clearErrorMessage();
            this.toggleDeleteScheduleBtn(schedule.layout.id);

        };

        this.renderActions = function () {
            var div = document.createElement("div");
            div.className = "Actions";

            this.scheduleActions = new Monet.UI.Fields.Render({
                label: '',
                type: 'RADIO_GROUP',
                id: 'schedulerAction',
                fieldDomains: [{
                        description: 'Greenmile.DataImport.FTP.deleteFile',
                        value: 'DELETE'
                    },
                    {
                        description: 'Greenmile.DataImport.FTP.moveTo',
                        value: 'MOVE'
                    }
                ]

            }).render();

            var radioGroupOptions = this.scheduleActions.rootEl.querySelectorAll('#RadioItem_schedulerAction');
            radioGroupOptions[0].className += ' delete';
            radioGroupOptions[1].className += ' move';

            this.folderNameToSaveFile = new Monet.UI.Fields.Render({
                label: 'Greenmile.DataImport.FTP.folderNameToSaveFile',
                type: 'TEXT',
                name: 'actionValue'
            }).render();

            this.scheduleActions.setId('schedulerAction');

            var label = document.createElement("label");
            label.innerHTML = Monet.I18n.getResourcesByKey("Greenmile.DataImport.FTP.Actions");
            div.appendChild(label);
            div.appendChild(this.scheduleActions.rootEl);

            var move = this.scheduleActions.rootEl.querySelector('#RadioItem_schedulerAction input[value="MOVE"]');
            move.parentNode.appendChild(this.folderNameToSaveFile.rootEl);

            return div;

        };

        this.getValue = function () {
            var schedule = this.scheduleList.input.value,
                name = this.scheduleName.getValue(),
                externalStorage = this.externalStorage.getValue(),
                fileName = this.fileName.getValue(),
                timeZone = this.timeZone.getValue(),
                schedulerInterval = this.schedulerInterval.getValue(),
                interval = this.runInterval.getValue(),
                intervalUnit = this.runIntervalUnit.getValue(),
                timeDay = this.timeDay.getValue(),
                layout = this.mappingTemplate.getValue(),
                importType = this.mappingTemplate.getTypeImportSelected(),
                data = {};

            if (schedule !== "NEW") {
                schedule = this.scheduleList.getValue();
                data.id = schedule;
            }
            data.importType = importType || 'PATCH';
            data.name = name;
            data.externalStorage = externalStorage;
            data.fileName = fileName;
            data.timeZoneId = timeZone.id;
            data.layout = (layout !== 'NEW' ? {
                id: parseInt(layout)
            } : null);

            if (this.scheduleActions.getValue()) {
                data.importActions = [{
                    actionType: this.scheduleActions.getValue()
                }];
                if (data.importActions[0].actionType === "MOVE") {
                    data.importActions[0].actionValue = this.folderNameToSaveFile.getValue();
                }
            }

            if (schedulerInterval === 'INTERVAL') {
                data.runInterval = interval;
                data.runIntervalUnit = intervalUnit;
            } else if (schedulerInterval === 'EVERYDAY') {
                data.runAt = timeDay;
            }

            return data;
        };

        this.validateActions = function (data, validateObj) {
            var item = this.scheduleActions.rootEl.querySelector('.radio_group_item.move');
            item.className = item.className.replace('control-group error', '');
            if (data.importActions && data.importActions[0].actionType === "MOVE" && !data.importActions[0].actionValue) {
                item.className += ' control-group error';
                validateObj.errorMessages.push({
                    message: Monet.I18n.getResourcesByKey('Greenmile.DataImport.fileDestinationIsMandatory')
                });
            }
        };

        this.validate = function (data) {

            var fieldsToValidate = ['scheduleName', 'externalStorage', 'fileName', 'timeZone'],
                validateObj = {
                    status: true,
                    errorMessages: []
                };

            this.validateFields(fieldsToValidate, validateObj);
            this.validateInterval(data, validateObj);
            this.validateActions(data, validateObj);
            this.validateLayout(data, validateObj);

            if (validateObj.errorMessages.length) {
                validateObj.status = false;
            }

            return validateObj;
        };

        this.renderExternalStorage = function () {
          const externalStorage = new Monet.UI.Fields.Render({
            label: 'Greenmile.DataImport.FTP.Connection',
            type: 'LOOKUP',
            name: 'externalStorage',
            lookupEntity: 'ExternalStorage',
            lookupEntityColumn: 'name',
            mandatory: true
          }, 'ExternalStorage');

          const externalStorageFields = fields.reduce((acc, item) => {
            acc[item.name] = item;

            return acc;
          }, {});

            App.Forms['LookupExternalStorage'] = {
              "layout": {
                "lookUpGrid": {
                  "sections": [
                    {
                      "sectionRelatedLists": [
                        {
                          "searchGridLayout": {
                            "id": 10115,
                            "entity": {
                              "key": "ExternalStorage"
                            },
                            "description": "ExternalStorage",
                            "kind": "PICKLIST",
                            "searchGridColumns": [
                              {
                                "id": 10997,
                                "columnOrder": 1,
                                "sizePixels": 200,
                                "field": {
                                  "id": 11361,
                                  "enabled": true,
                                  "maxSize": 255,
                                  ...externalStorageFields.name
                                }
                              },
                              {
                                "id": 10999,
                                "columnOrder": 3,
                                "sizePixels": 100,
                                "field": {
                                  "id": 11363,
                                  "enabled": true,
                                  "maxSize": 255,
                                  ...externalStorageFields.ftpPort
                                }
                              },
                              {
                                "id": 11000,
                                "columnOrder": 3,
                                "sizePixels": 200,
                                "field": {
                                  "id": 11364,
                                  "enabled": true,
                                  "maxSize": 255,
                                  ...externalStorageFields.ftpHost
                                }
                              }
                            ]
                          }
                        }
                      ]
                    }
                  ]
                }
              }
            };

            App.Forms['ExternalStorage'] = App.Forms['ExternalStorageExternalStorageLookup'] = {
              fields: externalStorageFields
            };

            this.externalStorage = externalStorage.render();
            return this.externalStorage;
        };

        this.renderScheduleFileName = function () {
            this.fileName = new Monet.UI.Fields.Render({
                label: 'Greenmile.DataImport.fileName',
                type: 'TEXT',
                name: 'fileName',
                mandatory: true
            }).render();

            return this.fileName;

        };

        this.render = function (self) {
            const rootClassName = 'schedules';
            this.rootEl.className = rootClassName;
            this.appendTitle('Greenmile.DataImport.Menu.schedules');
            this.rootEl.appendChild(self.entityPicklist.entityPicklist.rootEl);
            this.rootEl.appendChild(this.renderScheduleList().rootEl);
            const span = document.createElement("span");
            span.className = "divider";

            const templateList = this.mappingTemplate.render();
            this.mappingTemplate.setPostRenderRemoveNewOption();

            this.rootEl.appendChild(span);
            this.rootEl.appendChild(this.renderScheduleName().rootEl);
            this.rootEl.appendChild(this.renderExternalStorage().rootEl);
            this.rootEl.appendChild(this.renderScheduleFileName().rootEl);
            this.rootEl.appendChild(this.renderScheduleTime());
            this.rootEl.appendChild(this.renderActions());
            this.rootEl.appendChild(templateList);
            this.rootEl.appendChild(this.renderButtons());

            this.clearAndAppendRootEl(rootClassName);

            self.entityPicklist.afterChange = this.refreshScheduleList.bind(this);
            Greenmile.DataImport.Utils.clearErrorMessage();

        };

    }

    return FTP;
}());
